import { Route } from "react-router-dom";
import {
  UnitListPageErrorBoundary,
  UnitListPageLoader,
} from "./UnitListPage/loaders";
import { UnitListPage } from "./UnitListPage";
import { UnitDetailsPage } from "./UnitDetailsPage";
import { UnitPlanDetailsPage } from "./UnitPlanDetailsPage/UnitPlanDetailsPage";
import {
  UnitPlanDetailsPageErrorBoundary,
  UnitPlanDetailsPageLoader,
} from "./UnitPlanDetailsPage/loaders/UnitPlanDetailsPageLoader";
import {
  UnitDetailsPageErrorBoundary,
  UnitDetailsPageLoader,
} from "./UnitDetailsPage/loaders";
import { ProtectedRoute } from "~/context/ProtectedRoute";
import * as APITypes from "~/API";
import { ROUTES } from "~/utils";
import { unitListRouteHandle } from "~/components/Layout/Fallbacks/routeContentFallbackRegistry";

export const UnitPagesRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.unit}
        loader={UnitListPageLoader}
        handle={unitListRouteHandle}
        ErrorBoundary={UnitListPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <UnitListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.unitPlanDetails}
        loader={UnitPlanDetailsPageLoader}
        ErrorBoundary={UnitPlanDetailsPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <UnitPlanDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.unitDetails}
        loader={UnitDetailsPageLoader}
        ErrorBoundary={UnitDetailsPageErrorBoundary}
        element={
          <ProtectedRoute
            roles={[
              APITypes.TenantStatusType.Active,
              APITypes.TenantStatusType.InActive,
            ]}
          >
            <UnitDetailsPage />
          </ProtectedRoute>
        }
      />
    </>
  );
};
